import Checkbox from "@mui/material/Checkbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

export default function DiagnosticsChecks({ tasks }) {
  return (
    <List id="maintenance-page-controls-diagnostics-checks">
      {tasks.map((task, index) => (
        <ListItem key={index}>
          <ListItemIcon>
            <Checkbox color="secondary" />
          </ListItemIcon>
          <ListItemText primary={task} />
        </ListItem>
      ))}
    </List>
  );
}
